import { widgetState } from './widget.state';
import { widgetActions } from './widget.action';
import { widgetMutations } from './widget.mutation';

export default {
  namespaced: true,
  state: widgetState,
  getters: {},
  actions: widgetActions,
  mutations: widgetMutations,
};
